import { ProjectState, ProjectStateItem } from '@/lib/types/store/projects'
import { PayloadAction, createSlice } from '@reduxjs/toolkit'

const initialState: ProjectState = {
  items: [],
  loading: false,
  error: null,
  selectedProject: null,
  filterParams: null
}

const projectsSlice = createSlice({
  name: 'projects',
  initialState,
  reducers: {
    setProjects: (state, action: PayloadAction<ProjectStateItem[]>) => {
      state.items = action.payload
      state.loading = false
      state.error = null
    },
    updateProject: (state, action: PayloadAction<ProjectStateItem>) => {
      const index = state.items.findIndex(item => item.id === action.payload.id)
      if (index !== -1) {
        state.items[index] = action.payload
      } else {
        state.items.push(action.payload)
      }
      state.loading = false
      state.error = null
    },
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload
    },
    setError: (state, action: PayloadAction<string>) => {
      state.error = action.payload
      state.loading = false
    },
    setSelectedProject: (state, action: PayloadAction<ProjectStateItem | null>) => {
      state.selectedProject = action.payload
    },
    setFilterParams: (state, action: PayloadAction<Record<string, unknown> | null>) => {
      state.filterParams = action.payload
    },
    clearFilterParams: (state) => {
      state.filterParams = null
    }
  },
})

export const {
  setProjects,
  updateProject,
  setLoading,
  setError,
  setSelectedProject,
  setFilterParams,
  clearFilterParams
} = projectsSlice.actions

export default projectsSlice.reducer
